import { createReceiver } from '@resource/resource';
import { prefixAPI } from '@resource/api';

const COMMON_DATA_URL = prefixAPI('common-data/');

export const commonDataResource = createReceiver(COMMON_DATA_URL);
